var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDraggable',{attrs:{"use-holsters":"","is-active":_vm.isActive,"is-repeat":_vm.isRepeat,"hands":_vm.hands,"timer":_vm.timer},on:{"select":_vm.handleResult}})}
var staticRenderFns = []

export { render, staticRenderFns }